// contact-us page bundle -> dist/js/pages/contact-us.min.js
//
// Plain-ES port of the v3 contact-us interactions (originally a React/DCLogic
// component: dc/contact-us.logic.js on feat/v3-design-pages). No framework:
// nodes are re-selected via data-c-* hooks. Behaviours ported:
//   - the data-rv reveal (IntersectionObserver, same pattern as listing.js)
//   - topic/outcome chip selection + the hint line under each row
//   - inline field auto-width (measures the typed text in an offscreen sizer
//     span — mirrors the v3 sizeFields())
//   - name/email validation (blur-touched + submit-time), the live docket
//     rail (To/From/About/Reply-by + the progress ring + "N of 4"), and the
//     "Reply by" business-day date (replyBy())
//   - submit: a REAL AJAX POST to inc/pe-v2-contact.php
//     (pe_v2_contact_submit), not the v3 mock (the v3 logic.js never called a
//     network at all — submit() just flipped local React state). On success,
//     swaps to the "sent" view, matching the v3 design's instant transition.
//     On failure (e.g. a local mail-send failure — Brevo blocks the dev
//     container's IP, a known infra limit, not a bug), the form stays as-is
//     with no new UI, mirroring chrome.js's newsletter submit: a failed round
//     trip just does not flip to the success state, nothing more.
//   - "Send another brief" resets back to the form.
// The shared nav (scroll auto-hide, dropdown panels, mobile menu) lives in
// chrome.js and loads on every page.

(function () {
  "use strict";

  var root = document.querySelector(".pe-contact");
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // --- data-rv reveal (same IntersectionObserver options as listing.js) ----
  var revealables = $$("[data-rv]", root);
  if (revealables.length) {
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.opacity = "1";
            e.target.style.transform = "translateY(0)";
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      revealables.forEach(function (n) { io.observe(n); });
    } else {
      revealables.forEach(function (n) { n.style.opacity = "1"; n.style.transform = "translateY(0)"; });
    }
  }

  // --- direct-line copy buttons (call / email / linkedin) -------------------
  // Copies the row's value (not its label) to the clipboard, then swaps the
  // icon to a check for ~1.4s. Uses navigator.clipboard with a textarea +
  // execCommand fallback for older / non-secure-context browsers.
  function fallbackCopy(text) {
    try {
      var ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  }
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text)
        .then(function () { return true; })
        .catch(function () { return fallbackCopy(text); });
    }
    return Promise.resolve(fallbackCopy(text));
  }
  $$("[data-pe-copy]", root).forEach(function (btn) {
    var original = btn.getAttribute("aria-label");
    var revert;
    btn.addEventListener("click", function () {
      var text = btn.getAttribute("data-pe-copy") || "";
      copyText(text).then(function (ok) {
        if (!ok) return;
        btn.classList.add("is-copied");
        btn.setAttribute("aria-label", "Copied");
        clearTimeout(revert);
        revert = setTimeout(function () {
          btn.classList.remove("is-copied");
          if (original) btn.setAttribute("aria-label", original);
        }, 1400);
      });
    });
  });

  var form = $("[data-c-submit-form]", root);
  if (!form) return;

  // --- topic / outcome data (mirrors dc/contact-us.logic.js TOPICS/OUTCOMES,
  // including the routing `id` the server handler validates against) --------
  var TOPICS = [
    { id: "ff", label: "Future Fabric", desk: "Future Fabric — Org & Talent", line: "Org design, talent and the operating model around them." },
    { id: "tenx", label: "TenX Labs", desk: "TenX Labs — AI", line: "AI inside the work itself: agents, data and the adoption problem." },
    { id: "dayone", label: "OneNode", desk: "OneNode — Nano-GCC", line: "A capability centre in India, stood up end to end." },
    { id: "cwe", label: "Composite Workforce", desk: "Composite Workforce Enterprise", line: "People and agents run as one workforce, not two." },
    { id: "other", label: "something else", desk: "Whoever is closest to it", line: "Say it in your own words in the box below — we will find the right person." }
  ];
  var OUTCOMES = [
    { id: "cost", label: "Cost", line: "Tell us which process is expensive to run." },
    { id: "growth", label: "Growth", line: "Tell us what is holding growth back." },
    { id: "throughput", label: "Throughput", line: "Tell us where the work queues." },
    { id: "capability", label: "Capability", line: "Tell us what you cannot yet do in-house." }
  ];
  var RING = 2 * Math.PI * 46;
  var LIT = "#F4F9F8", DIM = "rgba(234,241,240,.5)", BLANK = "—";

  function findTopic(id) { return TOPICS.filter(function (t) { return t.id === id; })[0]; }
  function findOutcome(id) { return OUTCOMES.filter(function (o) { return o.id === id; })[0]; }

  var state = {
    name: "", company: "", email: "", phone: "", note: "",
    topic: "", outcome: "", news: false,
    nameTouched: false, emailTouched: false, tried: false
  };

  // --- field nodes -----------------------------------------------------------
  var nameEl = $("#pe-c-name", root);
  var companyEl = $("#pe-c-company", root);
  var emailEl = $("#pe-c-email", root);
  var phoneEl = $("#pe-c-phone", root);
  var noteEl = $("#pe-c-note", root);
  var newsEl = $("#pe-c-news", root);
  var sizer = $("[data-c-sizer]", root);
  var FIELD_IDS = ["pe-c-name", "pe-c-company", "pe-c-email", "pe-c-phone"];

  // --- inline field auto-width (measures against an offscreen sizer span,
  // same technique as the v3 sizeFields()) -----------------------------------
  function sizeFields() {
    if (!sizer) return;
    FIELD_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      sizer.textContent = el.value || el.placeholder || "";
      el.style.width = (sizer.offsetWidth + 14) + "px";
    });
  }

  // --- validation --------------------------------------------------------
  function emailOk(v) {
    var s = String(v).trim();
    var at = s.indexOf("@");
    if (at < 1) return false;
    var dot = s.indexOf(".", at + 2);
    return dot > at && dot < s.length - 1 && s.indexOf(" ") === -1;
  }

  // --- "Reply by" business-day date (Sat/Sun skipped), same algorithm and
  // format as dc/contact-us.logic.js's replyBy() ------------------------------
  var replyDaysHost = $("[data-c-reply-days]", root);
  var REPLY_DAYS = replyDaysHost ? (parseInt(replyDaysHost.getAttribute("data-c-reply-days"), 10) || 2) : 2;
  var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var WDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  function replyBy() {
    var days = REPLY_DAYS > 0 ? REPLY_DAYS : 2;
    var d = new Date();
    var moved = 0;
    while (moved < days) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) moved++;
    }
    return WDAYS[d.getDay()] + " " + d.getDate() + " " + MONTHS[d.getMonth()];
  }

  // --- chips: pick toggles on/off, updates the hint line below the row ------
  var topicLineEl = $("[data-c-topic-line]", root);
  var outcomeLineEl = $("[data-c-outcome-line]", root);

  function syncChips() {
    $$('[data-c-chip="topic"]', root).forEach(function (btn) {
      var on = btn.getAttribute("data-c-id") === state.topic;
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    $$('[data-c-chip="outcome"]', root).forEach(function (btn) {
      var on = btn.getAttribute("data-c-id") === state.outcome;
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var topic = findTopic(state.topic);
    var outcome = findOutcome(state.outcome);
    if (topicLineEl) topicLineEl.textContent = topic ? topic.line : "";
    if (outcomeLineEl) outcomeLineEl.textContent = outcome ? outcome.line : "";
  }
  $$("[data-c-chip]", root).forEach(function (btn) {
    btn.addEventListener("click", function () {
      var kind = btn.getAttribute("data-c-chip");
      var id = btn.getAttribute("data-c-id");
      if (kind === "topic") state.topic = (state.topic === id) ? "" : id;
      else state.outcome = (state.outcome === id) ? "" : id;
      syncChips();
      syncDocket();
      syncErrors();
    });
  });

  // --- the live docket rail: To / From / About / Reply by + the progress
  // ring + the "N of 4" counter ------------------------------------------------
  var countEl = $("[data-c-count]", root);
  var ringEl = $("[data-c-ring]", root);
  var markH = $('[data-c-mark="h"]', root);
  var markV = $('[data-c-mark="v"]', root);
  var docketTo = $('[data-c-docket="to"]', root);
  var docketFrom = $('[data-c-docket="from"]', root);
  var docketAbout = $('[data-c-docket="about"]', root);
  var docketReply = $('[data-c-docket="reply"]', root);
  var noteRow = $("[data-c-note-row]", root);
  var noteText = $("[data-c-note-text]", root);

  function syncDocket() {
    var nameSet = state.name.trim().length > 0;
    var mailSet = emailOk(state.email);
    var topicSet = state.topic !== "";
    var outcomeSet = state.outcome !== "";
    var done = (nameSet ? 1 : 0) + (mailSet ? 1 : 0) + (topicSet ? 1 : 0) + (outcomeSet ? 1 : 0);

    if (countEl) countEl.textContent = done + " of 4";
    if (ringEl) ringEl.setAttribute("stroke-dashoffset", (RING * (1 - done / 4)).toFixed(2));
    var markInk = done === 4 ? "#F2673A" : "rgba(255,255,255,.22)";
    if (markH) markH.setAttribute("stroke", markInk);
    if (markV) markV.setAttribute("stroke", markInk);

    var topic = findTopic(state.topic);
    var outcome = findOutcome(state.outcome);
    var who = nameSet ? (state.company.trim() ? state.name.trim() + " · " + state.company.trim() : state.name.trim()) : "";

    if (docketTo) { docketTo.textContent = topic ? topic.desk : BLANK; docketTo.style.color = topic ? LIT : DIM; }
    if (docketFrom) { docketFrom.textContent = who || BLANK; docketFrom.style.color = who ? LIT : DIM; }
    if (docketAbout) { docketAbout.textContent = outcome ? outcome.label : BLANK; docketAbout.style.color = outcome ? LIT : DIM; }
    if (docketReply) docketReply.textContent = replyBy();

    var hasNote = state.note.trim() !== "";
    if (noteRow) noteRow.style.display = hasNote ? "" : "none";
    if (noteText) noteText.textContent = state.note;
  }

  // --- field wiring ----------------------------------------------------------
  function bindInput(el, key) {
    if (!el) return;
    el.addEventListener("input", function () {
      state[key] = el.value;
      sizeFields();
      syncDocket();
    });
  }
  bindInput(nameEl, "name");
  bindInput(companyEl, "company");
  bindInput(emailEl, "email");
  bindInput(phoneEl, "phone");
  if (noteEl) noteEl.addEventListener("input", function () { state.note = noteEl.value; syncDocket(); });
  if (nameEl) nameEl.addEventListener("blur", function () { state.nameTouched = true; syncErrors(); });
  if (emailEl) emailEl.addEventListener("blur", function () { state.emailTouched = true; syncErrors(); });
  if (newsEl) newsEl.addEventListener("change", function () { state.news = newsEl.checked; });

  // --- inline error messages (only shown once a submit was tried, or once an
  // email field has been visited and left invalid) ---------------------------
  function showErr(name, on) {
    var el = $('[data-c-err="' + name + '"]', root);
    if (el) el.style.display = on ? "flex" : "none";
  }
  function syncErrors() {
    var nameSet = state.name.trim().length > 0;
    var mailSet = emailOk(state.email);
    showErr("name", state.tried && !nameSet);
    showErr("topic", state.tried && state.topic === "");
    showErr("outcome", state.tried && state.outcome === "");
    showErr("email-empty", state.tried && state.email.trim() === "");
    showErr("email-bad", (state.tried || state.emailTouched) && state.email.trim() !== "" && !mailSet);

    if (nameEl) nameEl.style.borderBottomColor = (state.tried && !nameSet) ? "#FF9E7A" : "rgba(255,255,255,.20)";
    if (emailEl) {
      var bad = ((state.tried || state.emailTouched) && state.email.trim() !== "" && !mailSet) || (state.tried && state.email.trim() === "");
      emailEl.style.borderBottomColor = bad ? "#FF9E7A" : "rgba(255,255,255,.20)";
    }
  }

  // --- submit: a real AJAX POST, then the "sent" view -----------------------
  var cfg = window.peV2Contact || {};
  var formWrap = $("[data-c-form]", root);
  var sentWrap = $("[data-c-sent]", root);
  var sending = false;

  function showSent() {
    var topic = findTopic(state.topic);
    var outcome = findOutcome(state.outcome);
    var who = state.company.trim() ? state.name.trim() + " · " + state.company.trim() : state.name.trim();
    var firstName = state.name.trim().split(/\s+/)[0];

    var thanks = $("[data-c-thanks]", root);
    if (thanks) thanks.textContent = firstName ? ("Thank you, " + firstName + ".") : "Thank you.";
    var body = $("[data-c-sent-body]", root);
    if (body) body.textContent = "It has gone to the desk that owns this work, and a person there will come back to you by " + replyBy() + ". Not an autoresponder, and not a sequence.";

    var sTo = $('[data-c-sent-docket="to"]', root); if (sTo) sTo.textContent = topic ? topic.desk : BLANK;
    var sFrom = $('[data-c-sent-docket="from"]', root); if (sFrom) sFrom.textContent = who || BLANK;
    var sAbout = $('[data-c-sent-docket="about"]', root); if (sAbout) sAbout.textContent = outcome ? outcome.label : BLANK;
    var sReply = $('[data-c-sent-docket="reply"]', root); if (sReply) sReply.textContent = replyBy();

    var sNoteRow = $("[data-c-sent-note-row]", root);
    var sNoteText = $("[data-c-sent-note-text]", root);
    var hasNote = state.note.trim() !== "";
    if (sNoteRow) sNoteRow.style.display = hasNote ? "" : "none";
    if (sNoteText) sNoteText.textContent = state.note;

    if (formWrap) formWrap.style.display = "none";
    if (sentWrap) sentWrap.style.display = "";
  }

  function resetForm() {
    state = {
      name: "", company: "", email: "", phone: "", note: "",
      topic: "", outcome: "", news: false,
      nameTouched: false, emailTouched: false, tried: false
    };
    form.reset();
    syncChips();
    syncDocket();
    syncErrors();
    sizeFields();
    if (sentWrap) sentWrap.style.display = "none";
    if (formWrap) formWrap.style.display = "";
  }
  var resetBtn = $("[data-c-reset]", root);
  if (resetBtn) resetBtn.addEventListener("click", resetForm);

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (sending) return;

    var nameSet = state.name.trim().length > 0;
    var mailSet = emailOk(state.email);
    var bad = !nameSet || !mailSet || !state.topic || !state.outcome;
    if (bad) {
      state.tried = true;
      state.nameTouched = true;
      state.emailTouched = true;
      syncErrors();
      var first = !nameSet ? nameEl : (!mailSet ? emailEl : null);
      if (first) first.focus();
      return;
    }

    if (!cfg.ajaxUrl) { showSent(); return; }

    sending = true;
    var fd = new FormData();
    fd.append("action", "pe_v2_contact_submit");
    fd.append("nonce", cfg.nonce || "");
    fd.append("name", state.name.trim());
    fd.append("company", state.company.trim());
    fd.append("email", state.email.trim());
    fd.append("phone", state.phone.trim());
    fd.append("note", state.note.trim());
    fd.append("topic", state.topic);
    fd.append("outcome", state.outcome);
    fd.append("news", state.news ? "1" : "0");
    fd.append("page", window.location.pathname);

    fetch(cfg.ajaxUrl, { method: "POST", body: fd })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        sending = false;
        if (data && data.success) showSent();
        // A failed round trip (validation error, or a local mail-send failure
        // — Brevo blocks the dev container's IP) leaves the form as-is, no new
        // UI, matching chrome.js's newsletter submit handling.
      })
      .catch(function () { sending = false; });
  });

  // --- pre-select from the URL (?outcome= / ?topic=) -------------------------
  // The home "Start a conversation" CTA passes the outcome the visitor picked
  // there (Cost / Growth / Throughput), so it arrives already chosen here.
  try {
    var qp = new URLSearchParams(window.location.search);
    var qOutcome = qp.get("outcome");
    var qTopic = qp.get("topic");
    if (qOutcome && findOutcome(qOutcome)) state.outcome = qOutcome;
    if (qTopic && findTopic(qTopic)) state.topic = qTopic;
  } catch (e) {}

  // --- initial paint ---------------------------------------------------------
  syncChips();
  syncDocket();
  syncErrors();
  sizeFields();
  window.addEventListener("resize", sizeFields);
})();
